import { Component, Injector, AfterViewInit, inject, ViewChild } from '@angular/core';
import { ADVOCATES, CANCEL, COMMON_MODULES, EMPLOYERS, ROUTES, SUCCESS } from '@app/core/constants';
import { ImageboxOneModule } from '@app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { IMAGES_URL } from '@app/core/constants/system-list.constant';
import { Router } from '@angular/router';
import { TermsOfUseModalComponent } from '@src/app/core/shared/components/terms-of-use-modal/terms-of-use-modal.component';
import { PrivacyPolicyModalComponent } from '@src/app/core/shared/components/privacy-policy-modal/privacy-policy-modal.component';
import { SharedDataService } from '@src/app/core/services';
import { CoreClass } from '@src/app/core/base/core.class';

declare var $: any;
// import * as $ from 'jquery';
@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [...COMMON_MODULES, ImageboxOneModule, TermsOfUseModalComponent, PrivacyPolicyModalComponent],
})
export class FooterComponent extends CoreClass implements AfterViewInit {
  public routes = ROUTES
  IMAGES_URL: string = IMAGES_URL;
  CANCEL = CANCEL
  SUCCESS = SUCCESS
  ADVOCATES = ADVOCATES;
  EMPLOYERS = EMPLOYERS;
  public route = inject(Router)
  @ViewChild(TermsOfUseModalComponent) termUseModalComp!: TermsOfUseModalComponent;
  @ViewChild(PrivacyPolicyModalComponent) privacyPolicyModalComp!: PrivacyPolicyModalComponent;

  constructor(
    injector: Injector
  ) {
    super(injector);
  }

  ngAfterViewInit() {
    // Using jQuery to toggle a class
    // $(document).on('click', '.footer-menu-item-title', function () {
    //   alert();
    // });
    // $('h1').click(function () {
    //   console.log('Helo');
    //   alert('Button clicked!');
    // });
  }

  public setLanguage(event: any) {
    const ln = event?.target?.value;
    const lang = { code: ln };
    this.localStorageService.setDataInLocalStorage({ key: 'language', value: lang }, false);
    this.reloadCurrentRoute();
    this.sharedService.setUserLanguage(ln);
    this.sharedService.setAppConfig();
    // this.sharedService.currentLanguage = ln;
  }
  reloadCurrentRoute() {
    const currentUrl = this.router.url; this.router.navigateByUrl(ROUTES.resolver, { skipLocationChange: true }).then(() => { this.router.navigate([currentUrl]); });
  }
  openTermUseModal() {
    this.termUseModalComp.open();
  }

  openPrivacyPoliciesModal() {
    this.privacyPolicyModalComp.open();
  }

}
